import type { TOC } from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';

interface QuestionsLoanTypesCardSignature {
  Args: {
    icon?: ComponentLike<{ Args: { size?: string | number } }>;
    imageAlt?: string;
    label: string;
    src?: string;
  };
  Element: HTMLDivElement;
}

const QuestionsLoanTypesCardComponent: TOC<QuestionsLoanTypesCardSignature> = <template>
  <div class="text-center tio-bg-sunken rounded-lg p-5 h-full" ...attributes>
    {{#if @icon}}
      <div class="mx-auto mb-3 flex items-center justify-center h-12 w-12 tio-fg-brand">
        <@icon @size="36" />
      </div>
    {{else if @src}}
      <img class="mx-auto mb-3 h-12 w-12" alt={{@imageAlt}} src={{@src}} />
    {{/if}}
    <span class="block tio-fg-secondary text-sm">{{@label}}</span>
  </div>
</template>;

export default QuestionsLoanTypesCardComponent;
